// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5b7fcfff","455":"24fd2600","488":"12cf2a8b","977":"10becd74"}[chunkId] + ".chunk.js";
};